import React from "react";
import { Card, CardHeader, CardContent, Grid, CardActionArea, Button, } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import ClusterFileUpload from "../components/clusterSimulations/ClusterFileUpload";
import useModule from "../hooks/useModule";
import { CAN, SUBJECTS } from "../auth/permissions";
import { MODULES } from "../services/Constants";
import Check from "../auth/ability";
import {
  ClusterImageStats,
  ClusterImageUploadDataGrid,
} from "../components/clusterSimulations";

const ClusterSimulations = () => {
  const { validateModuleWithMessage } = useModule();
  const [openModal, setOpenModal] = React.useState(false);
  const handleOpen = () => {
    if (!validateModuleWithMessage(MODULES.OTA)) return;
    setOpenModal(true);
  };
  const handleClose = () => setOpenModal(false);

  return (
    <div className="fragmentContainer">
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid size={{ xs: 2, sm: 12, md: 12, lg: 12 }} >
          <ClusterImageStats />
        </Grid>
        <Grid size={{ xs: 2, sm: 12, md: 12, lg: 12 }} >
          <Check I={CAN.CREATE} a={SUBJECTS.IMAGE}>
            <Grid size={{ xs: 2, sm: 2, md: 2, lg: 2 }} >
              <CardActionArea onClick={handleOpen}>
                <Button
                  variant="outlined"
                  startIcon={<CloudUploadIcon />}
                  sx={{ color: "#6750a4", backgroundColor: "#fff", width: "100%", borderRadius: '6px' }}
                >
                  UPLOAD NEW SIMULATION
                </Button>
              </CardActionArea>
              {openModal ? (
                <ClusterFileUpload
                  uploadType={"CLUSTER"}
                  handleClose={handleClose}
                  openModal={openModal}
                />
              ) : null}
            </Grid>
          </Check>
        </Grid>
        <Grid size={{ xs: 6, sm: 12, md: 12, lg: 12 }} >
          <Card variant="outlined">
            <CardHeader title="Available Clusters"></CardHeader>
            <CardContent sx={{ padding: 0 }}>
              <ClusterImageUploadDataGrid />
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </div>
  );
};

export default ClusterSimulations;
